import type {
	ArticlesDataFragment,
	GetProfileByUrlQuery,
} from '@/features/user-profile/graphql/queries/GetUserProfileByUrl.query';
import type { ProfileSpecificLinkType } from '@/@types/graphql-types';

export type UserProfileView = 'profile' | 'edit' | 'wtw';

export type ProfileNode = NonNullable<GetProfileByUrlQuery['profile']>;
export type ArticleNode = NonNullable<ArticlesDataFragment['edges']>[number]['node'];

export type ProfileLinkType = `${ProfileSpecificLinkType}`;
export const profileLinkTypes: ProfileLinkType[] = ['TWITTER', 'FACEBOOK', 'INSTAGRAM', 'LINKEDIN', 'WEBSITE', 'OTHER'];
export const socialLinkTypes: ProfileLinkType[] = ['TWITTER', 'FACEBOOK', 'INSTAGRAM', 'LINKEDIN'];
export const websiteLinkTypes: ProfileLinkType[] = ['WEBSITE', 'OTHER'];

/** Temp hardcoded list of profile/author IDs that require special behavior. */
export const influencerIds = [
	// BeHaind
	'5d59e0e0-9a7e-4d57-b9b7-2f6b21d0d7b1',
	'YXV8YTY0NmE2ZWEtNTI2NS00OTYxLTgwNWEtYWRlZDc2YWJiZjEy',

	// Nadja Gallera
	'32e94e65-f36f-4011-8eba-b5beea7c5546',
	'YXV8NmY5ODViMTItZDljYi00NTJiLThkMTgtOWJjNGFkOTkzMDRi',

	// Elyas M'Barek
	'2f156190-26c9-40da-b687-89338a3b193a',
	'YXV8ZTdlZTE1N2QtN2ZlYi00YWRjLWJiYmUtYmNhM2I2OGYxM2Y5',

	// Nikflixplus Niklas
	'511bfcda-2681-4806-8f45-4c02300ccd67',
	'YXV8NzFhOTIwZWQtZTQ4ZC00M2IyLWJlNWMtZGZkMmZiYjk4YTc4',

	// Steven Gatjen
	'e6243140-c93b-41b9-a623-644683f3a901',
	'YXV8YjMyN2FkOTktZWJiMi00OTM2LWFhNDItMjFiMTE2NWI0Y2I4',

	// Noah (Noahbasic)
	'a6d67c75-b69f-4cc0-aac3-e983aa92b05d',
	'YXV8ZjQwMGIyNjMtYjAxMy00MDE0LWIzYmYtNGI3YWM4ZjRkYTM2',

	// Karsten Runquist
	'2fdf03f0-637c-4ced-9567-73f1e8f7f427',
	'YXV8YzY2NGVmYzgtNjJlMS00ZDgzLTg0ODItODYxODc5NmMwOWNm',

	// CinemaDream
	'YXV8NzJmY2ZlZTEtYmM0Mi00OTliLTllZGMtMGUyNTViMTFmYTRl',
	'4e5b1e5c-e15c-4211-af6d-6ae72d6acf87',

	// Screenplayed (John)
	'YXV8NmNlMzgyODYtZDQ1YS00OWRhLTk0NmEtYThlZjMzNWE5ZTQy',
	'24a9a968-1c31-43d8-aef0-7fb46b03f331',

	// Cinematologist
	'YXV8YThhZWEzMWQtZTNjZi00ODQ3LTliZjktMjBmNjZjYTE3NTgz',
	'935800b8-258c-45b5-bd98-21729f2d0de3',

	// Nerdkultur (Marco)
	'YXV8YTJjYmVmM2MtYWNhZC00MjA4LWE1MWMtY2I4ODQwYzI5YjJi',
	'be069a3d-438f-4d79-b983-ae37d8247db4',

	// Jeremy Jahns
	'YXV8YjJjZTg0ZTctN2YwZi00MjIxLWEwODgtMDA3ODgyMTEyY2Nm',
	'2def0a15-f1fe-4112-ad5d-9d5fcb65058f',

	// BelYves
	'YXV8N2U0YmZmZDQtOWQxZS00NmQyLTg1ZTQtYjY0ODc0YWM5NWI2',
	'13c6d43c-2cd0-4e82-afd3-cecd7487ba5a',
];
